export default {
  'table.total': 'סה״כ: {{amount}} פריטים',
  'table.actions': 'פעולות',
};
